import {
  CLEAR_CRM_INTEGRATION,
  GET_CRM_INTEGRATION,
  SET_CRM_INTEGRATION,
} from "./CrmIntegrationTypes";

const initialState = {
  crmIntegration: "",
};

const CrmIntegrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CRM_INTEGRATION:
      return {
        ...state,
      };
    case SET_CRM_INTEGRATION:
      return {
        ...state,
        crmIntegration: action.payload,
      };

    case CLEAR_CRM_INTEGRATION:
      return {
        ...state,
        crmIntegration: null,
      };
    default:
      return state;
  }
};

export default CrmIntegrationReducer;
